import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BootstrapOfficialsComponent } from './components/bootstrap-officials/bootstrap-officials.component';

const routes: Routes = [
  {path:'', component:BootstrapOfficialsComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OfficialsRoutingModule { }
